/**
 * Default border corner style.
 *
 * @type {object}
 */
export const CORNER_DEFAULT_STYLE = Object.freeze({
  width: '6px',
  height: '6px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '#FFF'
});